<template>
  <div :class="['flex flex-col md:flex-row md:flex-wrap', withStyle ? 'gap-4' : 'gap-8']">
    <base-card :with-style="withStyle" padless :class="{ 'p-4': withStyle }">
      <p class="text-sm text-gray-700">Faktur Draft</p>
      <p class="mt-1 font-bold text-gray-900">{{ statusSummary.draft }}</p>
    </base-card>
    <base-card :with-style="withStyle" padless :class="{ 'p-4': withStyle }">
      <p class="text-sm text-gray-700">Faktur Belum Valid Kasir</p>
      <p class="mt-1 font-bold text-gray-900">{{ statusSummary.not_paid }}</p>
    </base-card>
    <base-card :with-style="withStyle" padless :class="{ 'p-4': withStyle }">
      <p class="text-sm text-gray-700">Faktur Belum Keluar Gudang</p>
      <p class="mt-1 font-bold text-gray-900">{{ statusSummary.not_packed }}</p>
    </base-card>
    <base-card :with-style="withStyle" padless :class="{ 'p-4': withStyle }">
      <p class="text-sm text-gray-700">Faktur Belum Dikirim</p>
      <p class="mt-1 font-bold text-gray-900">
        {{ statusSummary.not_shipped }}
      </p>
    </base-card>
    <base-card :with-style="withStyle" padless :class="{ 'p-4': withStyle }">
      <p class="text-sm text-gray-700">Faktur Belum Diambil</p>
      <p class="mt-1 font-bold text-gray-900">{{ statusSummary.not_taken }}</p>
    </base-card>
    <base-card :with-style="withStyle" padless :class="{ 'p-4': withStyle }">
      <p class="text-sm text-gray-700">Faktur Dikirim</p>
      <p class="mt-1 font-bold text-gray-900">{{ statusSummary.shipped }}</p>
    </base-card>
    <base-card :with-style="withStyle" padless :class="{ 'p-4': withStyle }">
      <p class="text-sm text-gray-700">Faktur Diambil</p>
      <p class="mt-1 font-bold text-gray-900">{{ statusSummary.taken }}</p>
    </base-card>
  </div>
</template>

<script>
export default {
  props: {
    statusSummary: Object,
    withStyle: {
      type: Boolean,
      default: true
    }
  }
}
</script>